import { Container, Text } from '@pixi/react'
import { Assets, TextStyle } from 'pixi.js'
import { Button, FeatureToggleType, formatToCommaWithLang, t, useChipSetStore, useFeatureToggleStore } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { useGameStore } from '../../domain/game/store/GameStore'
import extraBetOn from '../../../asset/images/buyBonus/Bet_btn_on.png'
import extraBetOff from '../../../asset/images/buyBonus/Bet_btn_off.png'
import extraBetOnUnable from '../../../asset/images/buyBonus/Bet_btn_on_unable.png'
import extraBetOffUnable from '../../../asset/images/buyBonus/Bet_btn_off_unable.png'
import extraBetOnHover from '../../../asset/images/buyBonus/Bet_btn_on_hover.png'
import extraBetOffHover from '../../../asset/images/buyBonus/Bet_btn_off_hover.png'
import { useMemo } from 'react'
import { useSelector } from '@xstate/react'
import { GameState, sweetBombMachine } from '../../../machine/sweetbombMachine'

Assets.addBundle('extrabet', {
  extraBetOn: { src: extraBetOn, loadParser: 'loadTextures' },
  extraBetOff: { src: extraBetOff, loadParser: 'loadTextures' },
  extraBetOnUnable: { src: extraBetOnUnable, loadParser: 'loadTextures' },
  extraBetOffUnable: { src: extraBetOffUnable, loadParser: 'loadTextures' },
  extraBetOnHover: { src: extraBetOnHover, loadParser: 'loadTextures' },
  extraBetOffHover: { src: extraBetOffHover, loadParser: 'loadTextures' },
})

const betTextStyle = new TextStyle({
  fill: '#ffffff',
  fontSize: 36,
  fontWeight: 'bold',
})

const desTextStyle = new TextStyle({
  fill: '#ffffff',
  fontSize: 20,
  fontWeight: '500',
})
const amountTextStyle = new TextStyle({
  fill: '#ffd600',
  fontSize: 36,
  fontWeight: 'bold',
  dropShadow: true,
  dropShadowColor: '#0b8e07',
  dropShadowBlur: 4,
  dropShadowAngle: Math.PI / 4,
  dropShadowDistance: 3,
})

export const ExtraBet = () => {
  const width = 539
  const height = 166
  const { isAnteBet } = useGameStore()
  const stake = useChipSetStore(x => x.computed.currentStake)
  const { isFreeGame, isShakeing } = useGameStore()
  const currentState = useSelector(sweetBombMachine, state => state)

  const featureToggle = useFeatureToggleStore(x => x.toggleList)
  const isDisableBuyBonus = !featureToggle.get(FeatureToggleType.disableBuyBonus)

  const isReelTableShake = useMemo(() => {
    return !isShakeing
  }, [isShakeing])

  const textAlphaSetting = useMemo(() => {
    if ((!isReelTableShake && currentState.matches(GameState.mainGame)) || !currentState.matches(GameState.mainGame)) {
      return 0.7
    }
    else {
      return 1
    }
  }, [currentState, isReelTableShake])

  const positionX = useMemo(() => {
    if (isDisableBuyBonus) {
      return gameConfig.resolution.width / 2 - 90
    }
    else {
      return 300
    }
  }, [isDisableBuyBonus])

  return (
    isFreeGame
      ? null
      : (
          <Container
            name="ExtraBet"
            x={positionX}
            y={gameConfig.resolution.height / 2 - 90}
            width={width}
            height={height}
          >
            <Button
              name="extraBet"
              x={0}
              y={0}
              width={width}
              height={height}
              enabled={isReelTableShake && currentState.matches(GameState.mainGame)}
              visible={true}
              defaultView={isAnteBet ? 'extraBetOn' : 'extraBetOff'}
              hoverView={isAnteBet ? 'extraBetOnHover' : 'extraBetOffHover'}
              disabledView={isAnteBet ? 'extraBetOnUnable' : 'extraBetOffUnable'}
              // pressedView="extraBet"
              onPress={() => {
                useGameStore.setState({
                  isAnteBet: !isAnteBet,
                })
              }}
            />

            <Text name="bet" anchor={[0.5, 0.5]} x={104} y={50} text={t('extraBet_bet')} style={betTextStyle} alpha={textAlphaSetting} />
            <Text name="betAmount" anchor={[0, 0.5]} x={180} y={50} text={`${formatToCommaWithLang(stake * 1.25)}`} style={amountTextStyle} alpha={textAlphaSetting} />
            <Text name="bet" anchor={[0.5, 0.5]}x={130} y={90} text={t('extraBet_content_1')} style={desTextStyle} alpha={textAlphaSetting} />
            <Text name="bet" anchor={[0.5, 0.5]}x={130} y={115} text={t('extraBet_content_2')} style={desTextStyle} alpha={textAlphaSetting} />

          </Container>
        ))
}
